import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles } from '@paintscout/ui'
import type { DialogProps, MuiTheme as Theme } from '@paintscout/ui'
import { Editor, FormSection } from '@paintscout/ui-business'
import React, { useRef } from 'react'
import ArrowBackIcon from '@material-ui/icons/ArrowBackIos'
import { makeHtml } from '@paintscout/util/util'
import type { UpdateableArea } from '@paintscout/util/builder'
import classnames from 'classnames'
import striptags from 'striptags'
import { useQuote } from '../../../context'

const useStyles = makeStyles((theme: Theme) => ({
  paddingTop: {
    paddingTop: theme.spacing(2)
  },
  paddingBottom: {
    paddingBottom: theme.spacing(2)
  }
}))

interface AreaNotesDialogProps extends DialogProps {
  area: UpdateableArea
  onConfirm: (area: UpdateableArea) => void
  onCancel: () => void
}

export default function AreaNotesDialog(props: AreaNotesDialogProps) {
  const { area, onConfirm, onCancel, ...dialogProps } = props
  const { isNoteEditable, isEditable } = useQuote()
  const classes = useStyles()
  const initialClientNote = makeHtml(area.clientNote, { replaceBreaks: true })
  const initialCrewNote = makeHtml(area.internalNote, { replaceBreaks: true })

  const internalNoteRef = useRef(null)
  const clientNoteRef = useRef(null)

  const handleConfirm = () => {
    const clientNote = clientNoteRef.current?.getHTML()
    const internalNote = internalNoteRef.current?.getHTML()

    onConfirm({
      ...area,
      clientNote: striptags(clientNote) ? clientNote : null,
      internalNote: striptags(internalNote) ? internalNote : null
    })
  }
  return (
    <Dialog open maxWidth="md" {...dialogProps}>
      <DialogTitle>Notes</DialogTitle>
      <DialogContent>
        <FormSection hideDivider style={{ paddingTop: 0 }} classes={{ root: classes.paddingBottom }}>
          <Editor
            label={'Client Note'}
            content={initialClientNote}
            fullWidth={true}
            ref={clientNoteRef}
            disabled={!isEditable}
          />
        </FormSection>

        <FormSection classes={{ root: classnames(classes.paddingBottom, classes.paddingTop) }}>
          <Editor
            label={'Crew Note'}
            content={initialCrewNote}
            fullWidth={true}
            ref={internalNoteRef}
            disabled={!isNoteEditable}
          />
        </FormSection>
      </DialogContent>
      <DialogActions
        leftButton={
          <Button icon={ArrowBackIcon} variant="text" onClick={onCancel}>
            Back
          </Button>
        }
      >
        <Button onClick={handleConfirm}>Confirm</Button>
      </DialogActions>
    </Dialog>
  )
}
